import React from 'react';
import _ from 'lodash';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { Input } from '../../../components/Form';

import styles from './ProductCustomFinDataSection.module.css';
import { limitToTwoDecimalPlaces } from '../../../utils/number';

const STATE = {
  ledgerIn: undefined,
  ledgerOut: undefined,
  vatIn: undefined,
  vatOut: undefined,
};

export class ProductCustomFinDataSection extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  setVatIn = e => {
    const { value } = e;
    this.props.onFieldChanged({ name: 'vatIn', value }, this.props.data.taxRegion);
  };

  setVatOut = e => {
    const { value } = e;
    this.props.onFieldChanged({ name: 'vatOut', value }, this.props.data.taxRegion);
  };

  setPrice = e => {
    const { name, value } = e.target;
    this.props.onFieldChanged({ name, value }, this.props.data.taxRegion);
  };

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  get vatCodeOptions() {
    return this.vatCodes.map(vatCode => ({ value: vatCode.code, label: `${vatCode.code} : ${vatCode.description}` }));
  }

  get vatInCodeLabel() {
    const code = this.state.vatIn === undefined ? this.props.data.vatIn : this.state.vatIn;
    const vatCodeObj = this.getVatCodeObject(code);

    if (!vatCodeObj) return '';
    return `${vatCodeObj.code} : ${vatCodeObj.description}`;
  }

  get vatOutCodeLabel() {
    const code = this.state.vatOut === undefined ? this.props.data.vatOut : this.state.vatOut;
    const vatCodeObj = this.getVatCodeObject(code);

    if (!vatCodeObj) return '';
    return `${vatCodeObj.code} : ${vatCodeObj.description}`;
  }

  getVatCodeObject(code) {
    return this.vatCodes.find(vatCode => vatCode?.code === code);
  }

  setLedgerIn = e => {
    const { value } = e;
    this.props.onFieldChanged({ name: 'ledgerIn', value }, this.props.data.taxRegion);
  };

  setLedgerOut = e => {
    const { value } = e;
    this.props.onFieldChanged({ name: 'ledgerOut', value }, this.props.data.taxRegion);
  };

  get ledgers() {
    return this.props.ledgers ?? [];
  }

  get ledgerOptions() {
    return this.ledgers.map(ledger => ({
      value: ledger.ledgerNumber,
      label: `${ledger.ledgerNumber} : ${ledger.description}`,
    }));
  }

  get ledgerInLabel() {
    const ledgerNumber = this.state.ledgerIn === undefined ? this.props.data.ledgerIn : this.state.ledgerIn;
    const value = this.ledgers.find(ledger => ledger?.ledgerNumber === ledgerNumber);

    if (!value) return '';
    return `${value?.ledgerNumber} : ${value?.description}`;
  }

  get ledgerOutLabel() {
    const ledgerNumber = this.state.ledgerOut === undefined ? this.props.data.ledgerOut : this.state.ledgerOut;
    const value = this.ledgers.find(ledger => ledger?.ledgerNumber === ledgerNumber);

    if (!value) return '';
    return `${value?.ledgerNumber} : ${value?.description}`;
  }

  render() {
    return (
      <HBox gap="16px" style={{ marginTop: '24px', flexDirection: window.innerWidth < 500 && 'column' }}>
        <VBox left>
          <FormField label={this.lbl('product.create.vat_in')}>
            <SearchSelect
              minWidth="100%"
              value={this.vatInCodeLabel && { label: this.vatInCodeLabel }}
              options={this.vatCodeOptions}
              onChange={this.setVatIn}
            />
          </FormField>

          <div className={styles.inputContainer}>
            <label className="form-label">{this.lbl('product.create.purchase_price')}</label>
            <input
              name="purchasePrice"
              className="form-control"
              value={limitToTwoDecimalPlaces(this.props.data.purchasePrice)}
              type="text"
              onChange={this.setPrice}
            />
          </div>

          <FormField label={this.lbl('product.create.ledger_in')}>
            <SearchSelect
              minWidth="100%"
              options={this.ledgerOptions}
              value={this.ledgerInLabel && { label: this.ledgerInLabel }}
              onChange={this.setLedgerIn}
            />
          </FormField>
        </VBox>

        <VBox left>
          <FormField label={this.lbl('product.create.vat_out')}>
            <SearchSelect
              minWidth="100%"
              options={this.vatCodeOptions}
              value={this.vatOutCodeLabel && { label: this.vatOutCodeLabel }}
              onChange={this.setVatOut}
            />
          </FormField>

          <div className={styles.inputContainer}>
            <label className="form-label">{this.lbl('product.create.sales_price')}</label>
            <input
              name="salesPrice"
              className="form-control"
              value={limitToTwoDecimalPlaces(this.props.data.salesPrice)}
              type="text"
              onChange={this.setPrice}
            />
          </div>

          <FormField label={this.lbl('product.create.ledger_out')}>
            <SearchSelect
              minWidth="100%"
              options={this.ledgerOptions}
              value={this.ledgerOutLabel && { label: this.ledgerOutLabel }}
              onChange={this.setLedgerOut}
            />
          </FormField>
        </VBox>
      </HBox>
    );
  }
}
